import { ICONS } from '@react-ui-kit/icons/icon-paths';

export const __IS_CLIENT = typeof window !== 'undefined';
export const __IS_SERVER = !__IS_CLIENT;

export const ERROR_LOGGING_PATTERN = (version: string, route: string) => {
  return `${version} || ${route} ROUTE ||`;
};

export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 12;
export const DEFAULT_SORT_BY = 'createdAt';
export const DEFAULT_SORT_DIR = 'desc';

export const IMAGE_PLACEHOLDER = '/icons/question.svg';

export enum COOKIE_KEYS {
  SESSION = 'session',
  USER_ID = 'uid'
}

export enum SWR_CACHE_KEYS {
  USER = 'USER',
  AUTHORS = 'AUTHORS',
  BOOKS = 'BOOKS',
  GOOGLE_BOOKS = 'GOOGLE_BOOKS',
  QUOTES = 'QUOTES',
  QUOTE = 'QUOTE',
  MEME = 'MEME'
}

export enum SEARCH_PARAMS_UNCACHED {
  USERNAME = 'userName'
}

export const TELEGRAM_LINK = 'https://t.me/DRabus';
export const GITHUB_LINK = 'https://github.com/DaRabus';
export const LINKED_IN_LINK = 'https://www.linkedin.com/in/dominik-rabus/';
export const EMAIL_LINK = 'mailto:hello@rabus.me';

export interface LinkProperties {
  name: string;
  icon?: string;
  link: string;
  protected?: boolean;
}

export const PROFILE_HEADER_LINKS: LinkProperties[] = [
  {
    name: 'Login',
    link: '/login',
    icon: ICONS.LOGIN
  },
  {
    name: 'Register',
    link: '/register',
    icon: ICONS.REGISTER
  },
  {
    name: 'Logout',
    link: '/logout',
    protected: true,
    icon: ICONS.LOGOUT
  },
  {
    name: 'Profile',
    link: '/profile',
    protected: true,
    icon: ICONS.PROFILE
  },
  {
    name: 'Create Quote',
    link: '/quote/create',
    protected: true,
    icon: ICONS.QUOTE
  },
  {
    name: 'Create Book',
    link: '/book/create',
    icon: ICONS.BOOK,
    protected: true
  },
  {
    name: 'Create Author',
    link: '/author/create',
    protected: true,
    icon: ICONS.AUTHOR
  },
  {
    name: 'Create Meme',
    link: '/meme/create',
    protected: true,
    icon: ICONS.MEME
  }
];

export const HEADER_LINKS: LinkProperties[] = [
  {
    name: 'Home',
    link: '/'
  },
  {
    name: 'Quotes',
    link: '/quotes'
  },
  {
    name: 'Books',
    link: '/books'
  },
  {
    name: 'Authors',
    link: '/authors'
  },
  {
    name: 'Memes',
    link: '/memes'
  }
];

export const SOCIAL_LINKS: LinkProperties[] = [
  {
    name: 'Telegram',
    icon: ICONS.TELEGRAM,
    link: TELEGRAM_LINK
  },
  {
    name: 'Linked In',
    icon: ICONS.LINKEDIN,
    link: LINKED_IN_LINK
  },
  {
    name: 'Email',
    icon: ICONS.EMAIL,
    link: EMAIL_LINK
  },
  {
    name: 'Github',
    icon: ICONS.GITHUB,
    link: GITHUB_LINK
  }
];
